module.exports = __webpack_public_path__ + "static/media/ic_driver_main@3x.d91f9071.png";